import React, { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
import useOperationFormById from 'screens/Applications&WorkOrders/Components/hooks/useOperationFormById';
import { useFormikContext } from 'formik';
import _ from 'lodash';
import { initialValues } from 'screens/Applications&WorkOrders/StepsLayout/Constants/formikData';
import { useAgOperationUtility } from 'screens/Applications&WorkOrders/StepsLayout/Context/AgOperationUtilityProvider';
import StepsLayout from '../../../StepsLayout';
import { differenceBetweenApplications } from '../../../StepsLayout/Components/ProductsStep/components/ProductsTable/helpers';

const EditApplication: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [hasChanges, setHasChanges] = useState(false);
  const { values, setValues, setTouched } = useFormikContext<any>();
  const { setOriginalDates } = useAgOperationUtility();

  const { loading, operationFormikData } = useOperationFormById(
    id,
    'application'
  );

  useEffect(() => {
    if (!loading && operationFormikData) {
      setValues(operationFormikData);
      setTouched({});
      // Store original dates to detect if dates have changed when saving
      if (
        operationFormikData.startDateTime &&
        operationFormikData.endDateTime
      ) {
        setOriginalDates(
          operationFormikData.startDateTime,
          operationFormikData.endDateTime
        );
      }
    }
  }, [loading, operationFormikData, setValues, setTouched, setOriginalDates]);

  useEffect(() => {
    if (operationFormikData === undefined || _.isEqual(values, initialValues))
      return;

    const { changedFields, products } = differenceBetweenApplications(
      values,
      operationFormikData
    );

    const hasChangesInApplication =
      changedFields.length > 0 || Object.values(products).flat().length > 0;

    setHasChanges(hasChangesInApplication);
  }, [values, operationFormikData]);

  return <StepsLayout isEditMode isLoading={loading} hasChanges={hasChanges} />;
};

export default EditApplication;
